

Object.defineProperty(exports, '__esModule', { value: true });
const wechat_1 = require('./device/wechat');
const native_1 = require('./device/native');
const pc_1 = require('./device/pc');
const runtime_1 = require('./libs/runtime');

const Runtime = /** @class */ (function () {
  function Runtime() {
    if (runtime_1.isRunOnMobile()) {
      if (runtime_1.isRunOnWechat()) {
        this.runtimeName = 'wechat';
      } else if (runtime_1.isRunOnDwdApp()) {
        this.runtimeName = 'native';
      } else {
        console.warn('不支持当前运行环境');
      }
    } else if (runtime_1.isRunOnWechat()) {
      this.runtimeName = 'wechat';
    } else {
      this.runtimeName = 'pcWeb';
    }
  }
  Runtime.prototype.mountApis = function () {
    if (this.runtimeName === 'wechat') {
      this.exportApis = new wechat_1.weChat(this.runtimeName);
    } else if (this.runtimeName === 'pcWeb') {
      this.exportApis = new pc_1.pcWeb(this.runtimeName);
    } else if (this.runtimeName === 'native') {
      this.exportApis = new native_1.native(this.runtimeName);
    }
  };
  return Runtime;
}());
exports.default = Runtime;
